import './AnswerSubmittedScreen.css';
import Footer from '../../_Components/Footer';
import Lottie from 'lottie-react';
import hourglass from '../../../assets/images/animations/hourglass.json';
import { SuccessBadgeIcon } from '../../../components/Icons';

const AnswerSubmittedScreen = ({
  onNextQuestion,
  isLastQuestion = false,
  currentQuestion = 0,
  totalQuestions = 0
}) => {
  return (
    <div className='answer-submitted-screen'>
      <div id='container'>
        <div className='main-content answer-submitted-content'>
        <div className='feedback-message'>
          <div className='success-badge'>
            <SuccessBadgeIcon />

            <span>Risposta inviata!</span>
          </div>
        </div>

        <div className='waiting-section'>
          <div className='hourglass-icon'>
            <Lottie
              animationData={hourglass}
              autoPlay={true}
              loop={true}
              id='loader_animation'
              className='loading-animation'
            />
          </div>

          <div className='waiting-message'>
            <h1>
              {isLastQuestion
                ? 'Quiz completato!'
                : 'Aspetta il via del docente'
              }
            </h1>
            <p>
              {isLastQuestion
                ? 'Hai completato tutte le domande. Il docente comunicherà i prossimi passi.'
                : <>
                  Prima di proseguire assicurati di seguire le
                  <br />
                  istruzioni del docente in aula
                </>
              }
            </p>

          </div>

          <button onClick={onNextQuestion}>
            {isLastQuestion ? 'Termina Quiz' : 'Prossima domanda'}
          </button>
        </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default AnswerSubmittedScreen;
